import { Pipe, PipeTransform } from '@angular/core';
import { SearchRes } from '../services/Search/search.service';

@Pipe({
  name: 'orderSearchByDate'
})
export class OrderSearchByDatePipe implements PipeTransform {

transform(res: SearchRes[]): SearchRes[] {
        return res.sort((a, b) => {
            return a.movie.Release - b.movie.Release
        })
    }
}
